import React from "react";
import { Outlet, Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { Brain, FileText, Home, LogOut, PlusCircle, Mail, KeyRound } from "lucide-react";

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col lg:flex-row">
      {/* Sidebar */}
      <aside className="lg:w-64 lg:fixed lg:h-screen bg-slate-900 text-slate-200 flex flex-col">
        <div className="p-5 border-b border-slate-800">
          <Link to="/admin" className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center text-white">
              <Brain size={20} />
            </div>
            <div>
              <div className="font-bold text-white">Admin Panel</div>
              <div className="text-xs text-slate-400">Mental Mente Sano</div>
            </div>
          </Link>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          <AdminLink to="/admin" icon={Home} end>Dashboard</AdminLink>
          <AdminLink to="/admin/articulos" icon={FileText}>Artículos</AdminLink>
          <AdminLink to="/admin/articulos/nuevo" icon={PlusCircle}>Nuevo artículo</AdminLink>
          <AdminLink to="/admin/mensajes" icon={Mail}>Mensajes</AdminLink>
          <AdminLink to="/admin/cambiar-password" icon={KeyRound}>Cambiar contraseña</AdminLink>
        </nav>

        <div className="p-4 border-t border-slate-800">
          <div className="mb-3 px-2">
            <div className="text-xs text-slate-500 uppercase tracking-wider">Conectado como</div>
            <div className="text-sm font-semibold text-white truncate">{user?.name || user?.email}</div>
            <div className="text-xs text-slate-400 truncate">{user?.email}</div>
          </div>
          <Link to="/" className="block w-full text-center px-3 py-2 rounded-lg border border-slate-700 hover:bg-slate-800 text-sm mb-2 transition">
            Ver sitio público
          </Link>
          <button onClick={handleLogout} className="flex items-center justify-center gap-2 w-full px-3 py-2 rounded-lg bg-rose-600/90 hover:bg-rose-600 text-white text-sm font-medium transition">
            <LogOut size={16} /> Cerrar sesión
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 lg:ml-64 p-4 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}

function AdminLink({ to, icon: Icon, end, children }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition ${
          isActive ? "bg-cyan-600 text-white" : "text-slate-300 hover:bg-slate-800 hover:text-white"
        }`
      }
    >
      <Icon size={17} />
      {children}
    </NavLink>
  );
}
